import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/elgamal");
  };

  return (
    <div className="flex justify-center">
      <div className="flex flex-col items-center">
        <div>
          <h1 className="text-3xl pt-8">Elliptic-curve Diffie–Hellman (ECDH) Key Exchange Protocol</h1>
        </div>
        <div className="pt-10">
          <h1>Instructions</h1>
        </div>
        <div class="instruction-box">
        <p>
  <strong>Welcome to Experiment 10: Elliptic-curve Diffie–Hellman (ECDH) Key Exchange Protocol</strong>
  <br /><br />

  → Begin by understanding the fundamentals of ECDH, a key exchange protocol based on elliptic curve cryptography.
  <br /><br />

  → Explore the elliptic curve parameters (a, b, and q) for Curve25519. Select a point G on the curve with a large order (n).
  <br /><br />

  → In Step 2, simulate the process for User A. Choose a private key (nA) and calculate the corresponding public key (PA = nA * G).
  <br /><br />

  → Proceed to Step 3, simulating the process for User B. Choose a private key (nB) and calculate the corresponding public key (PB = nB * G).
  <br /><br />

  → In Step 4, calculate the secret key for User A (K = nA * PB).
  <br /><br />

  → In Step 5, calculate the secret key for User B (K = nB * PA).
  <br /><br />

  → Dive into the simulation by clicking the "Start Simulation" button. Visualize the elliptic curve and witness the dynamic generation of public and private keys.
  <br /><br />

  → Gain insights into how the secret keys are computed using elliptic curve operations. Track the process step-by-step and observe the final shared secret keys for both users.
  <br /><br />

  → Use the side panel to view specific values such as G and other parameters, enhancing your understanding of the ECDH protocol.
  <br /><br />

  → Throughout the simulation, a box on the side explains each step, providing clarity on the calculations and their significance.
  <br /><br />

  <strong>Note:</strong> Take advantage of the interactive nature of this simulation to solidify your comprehension of ECDH. Document your observations and insights for a comprehensive understanding of key exchange using elliptic curves.
</p>
        </div>
        <div class="button-holder">
          <div class="next-button" onClick={firstpage}>
            NEXT
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
